import React from 'react';
import PropTypes from 'prop-types';
import { Title } from '../../../ReportStyles';
import { Item } from '../DarkWebModalStyles';
import { INDEX_FIELDS, VIEWS } from '../../DarkWebConstants';

const IndexView = ({ hasDriverLicense, hasPassportNumber, setView }) => {
  return (
    <>
      <Title>What would you like to monitor?</Title>
      {INDEX_FIELDS.map(({ view, label }) => {
        const item = (
          <Item key={view} onClick={() => setView(view)}>
            {label}
          </Item>
        );
        if (view === VIEWS.PASSPORT_NUMBER) {
          return !hasPassportNumber && item;
        }
        if (view === VIEWS.DRIVER_LICENSE) {
          return !hasDriverLicense && item;
        }
        return item;
      })}
    </>
  );
};

IndexView.propTypes = {
  hasDriverLicense: PropTypes.bool.isRequired,
  hasPassportNumber: PropTypes.bool.isRequired,
  setView: PropTypes.func.isRequired,
};

export default IndexView;
